<template>
  <div class="md-layout text-main-black">
    <div class="md-layout-item md-size-100 mobile-layout">
      <md-card class="mobile-card feedback-card text-main-black">
        <md-card-content class="mobile-content">
          <div class="feedback-card-wrapper">
            <div class="table-title md-theme-block-head-color">
              ВАШЕ СООБЩЕНИЕ
            </div>
            <md-field maxlength="5">
              <label :class="{'custom-valid-label': description && description.length > 0}">
                Укажите какую информацию необходимо обновить
              </label>
              <md-textarea v-model="description" />
            </md-field>

            <div class="feedback-card-user-info">
              <div class="text-grey-1"><strong>Дом:</strong>{{ addressLabel }}</div>
              <div class="text-grey-1"><strong>Управляющая:</strong>{{ manageorganization }}</div>
            </div>

            <div
              :class="$checkMobile() ? 'text-align-center': 'text-align-right'"
              class="md-layout-item md-small-size-100 md-layout-item-field">
              <md-button class="md-blue create-btn"
                         @click="submit"
                         :disabled="loader"
              >
                <circle-loader v-if="loader" :diameter="20" />
                <span v-else>Отправить</span>

              </md-button>
            </div>
          </div>
        </md-card-content>
      </md-card>
    </div>
  </div>
</template>

<script>
import { mapGetters } from "vuex";
import CircleLoader from '@/components/Custom/CircleLoader';
import api from "@/api";
import to from "await-to-js";


export default {
  name: "FeedbackPage",
  data() {
    return {
      description: null,
      loader: false
    }
  },
  components: {
    CircleLoader
  },
  computed: {
    ...mapGetters([
      'getPersonalAccountInfo',
      'getUsername'
    ]),

    addressLabel() {
      if (this.getPersonalAccountInfo) {
        const { thoroughfare, premise, objectname, number} = this.getPersonalAccountInfo.apartment;
        return `${thoroughfare} ${premise}, ${objectname} ${number}`;
      }
      return '';
    },

    manageorganization() {
      if (this.getPersonalAccountInfo) {
        const { manageorganization } = this.getPersonalAccountInfo.personalAccount;
        return manageorganization;
      }
      return '';
    },
  },
  methods: {
    async submit() {
      const { premiseId } = this.getPersonalAccountInfo.apartment;
      const { description, getUsername } = this
      if (!description || description && description.length <= 5) {
        this.$notifyDanger('Опишите детальней о проблеме или ошибке');
        return;
      }

      const body = {
        kind: 'A',
        premiseId: premiseId,
        comments: description,
        username: getUsername
      }
      const [err] = await to(api.user.submitFeedback(body));

      if (err) {
        this.$notifyDanger('Ошибка');
        return;
      }
      const name = this.$checkMobile() ? 'Main' : 'Appeals'
      this.$notifySuccess('Отправлено');
      this.$router.push({ name });
    }
  }
};
</script>

<style scoped lang="scss">
.feedback-card {
  max-width: 785px;
  @media (max-width: 768px) {
    margin-bottom: 0;
  }
  .md-card-content {
    padding: 25px 20px;
    @media (max-width: 768px) {
      height: calc(100vh - 65px);
    }
  }

  &-wrapper {
    padding: 0 10px;
  }

  &-user-info {
    margin: 15px 0;
    strong {
      margin-right: 5px;
    }
  }
}
</style>
